import { useMemo } from 'react'
import { matchesFilter } from '@/logic/filters'
import { useAuth } from '@/store/auth'
import { usePrefs } from '@/store/prefs'
import { useTasks } from '@/store/tasks'
import type { Task } from '@/types'

const NONE: Task[] = []

/** Every loaded task that passes the one set of filters, with any loaded apart (a past week's) added. */
export function useVisibleTasks(extra: Task[] = NONE): Task[] {
  const uid = useAuth((s) => s.user?.uid ?? '')
  const tasks = useTasks((s) => s.all)
  const filter = usePrefs((s) => s.filter)
  return useMemo(() => {
    const seen = new Set(tasks.map((t) => t.id))
    return tasks.concat(extra.filter((t) => !seen.has(t.id))).filter((t) => matchesFilter(t, filter, uid))
  }, [tasks, extra, filter, uid])
}
